import {FC} from 'react'
import {DataCDR} from '../../core/_models'

type Props = {
  data: DataCDR
}

const CDRIcons: FC<Props> = ({data}) => {
  return (
    <div className='d-flex align-items-center'>
      {data.direction === 'INBOUND' ? (
        <>
          {data.status === 'ANSWERED' ? (
            <i className='bi bi-arrow-down-right-circle fs-2  text-primary' />
          ) : (
            <i className='bi bi-x-circle fs-2 text-danger' />
          )}
        </>
      ) : (
        <i className='bi bi-arrow-up-left-circle fs-2 text-success' />
      )}
    </div>
  )
}

export {CDRIcons}
